module.exports = __webpack_public_path__ + "img/img1.22695e6d.png";